"use client";

/**
 * The one lazy `HotelBookingModal`, so the booking form and Stripe only load when a hotel-booking
 * CTA actually opens. Shared by `useHotelBookingCta` and `CtaStepSequenceDialog` so the dynamic
 * import (ssr flag, path) lives in one place.
 */

import dynamic from "next/dynamic";

/** `HotelBookingModal`, code-split and client-only. Takes the same props. */
export const LazyHotelBookingModal = dynamic(() => import("./HotelBookingModal").then((mod) => mod.HotelBookingModal), {
  ssr: false,
});
